import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 17h.01", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "HelpCircle";
const HelpCircle = memo(themed(Icon));
export {
  HelpCircle
};
//# sourceMappingURL=help-circle.js.map
